<template>
  <div class="row align-items-center">
    <form class="col-sm pb-2 text-right">
      <input
        type="text"
        class="form-control rounded-0 bg-transparent border-secondary border-top-0 border-right-0 border-left-0"
        placeholder="Filter..."
        v-model="query"
        name="inputQuery"
      />
    </form>
    <div class="col-12" v-for="(item,key) in filteredResults" :key="key">
        <div class="card my-2 shadow-sm">
          <div class="card-body">
            <h5 class="card-title"><a href="#" @click="showDetails(key)">{{ item.company_name }}</a></h5>
            <h6 class="card-subtitle mb-2 text-muted">{{ item.heading }}</h6>
            <p>{{ item.description }}</p>
            <button class="btn btn-primary" @click="showDetails(key)">View</button>
          </div>
        </div>
    </div>
    <ModalDetail
      ref="modalDetail"
      :item="selected">
    </ModalDetail>
  </div>
</template>
<script>
import ModalDetail from "./ModalDetail";
import dataResults from "../data/results.json";

export default {
  data() {
    return {
      results: dataResults,
      selected: {},
      query: ''
    }
  },
  components: {
    ModalDetail
  },
  computed: {
    filteredResults() {
      return this.results.filter((item) => {
        if (typeof item != "undefined") {
          return item.company_name.toLowerCase().includes(this.query.toLowerCase());
        }
      })
    }
  },
  methods: {
    showDetails(idx) {
      this.selected = this.results[idx];
      this.$refs.modalDetail.show();
    }
  }
};
</script>
